const actions = {
  SET_BREADCRUMB: 'SET_BREADCRUMB',
  setBreadcrumb: breadcrumbs => ({
    type: actions.SET_BREADCRUMB,
    payload: breadcrumbs,
  }),
};

export default actions;
